<template>
  <div class="text-center">
    <v-dialog scrollable v-model="dialog" ref="dlgInfo" width="650">
      <template v-slot:activator="{}"></template>

      <v-card>
        <v-card-title class="headline">Grup Komunitas</v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="2" sm="2" md="2" lg="2" xl="2">
              <v-img src="https://cdn.siap.id/s3/simpkb/asset img/guru-praktik-baik/modal-telegram.png"></v-img>
            </v-col>
            <v-col cols="10" sm="10" md="10" lg="10" xl="10">
              <div class="text-left mb-0 pb-0">
                <p>Gunakan tautan berikut untuk bergabung di Grup Komunitas <b>{{current_instansi.nama}}</b></p>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black--text" text @click="closeGuide">Tutup</v-btn>
          <v-btn color="primary" @click="toJoin" :loading="loading">Bergabung</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//@group Global Feature
export default {
  name: "home-form-join-telegram",
  data() {
    return {
      dialog: false,
      config: null,
      loading: false,
    };
  },

  methods: {
    //@vuese
    //buka dialog dan ambil data konfigurasi telegram
    // eslint-disable-next-line
    open() {
      this.dialog = true;
      this.loadConfig();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },
    //@vuese
    //tutup dialog
    closeGuide() {
      this.dialog = false;
      this.resolve();
    },
    //@vuese
    //buka link join telegram sesuai konfigurasi
    toJoin() {
      window.open( this.config.string, "_blank");
      this.dialog = false;
      this.resolve();
    },
    //@vuese
    //ambil data konfigurasi telegram
    loadConfig() {
      this.loading = true;
      return this.$store
        .dispatch("instansi/config", {
          instansi_id: this.instansi_id,
        })
        .then((res) => {
          var configKomunitas = res.filter((r) => (r.key == "url_komunitas"));
          this.config = configKomunitas && configKomunitas.length > 0 ? configKomunitas[0] : null;
          this.loading = false;
        })
        .catch((e) => e);
    },
  },
};
</script>
